<template>
  <main class="container-fluid">
    <section style="margin-left: 10px;">
      <h4 class="text-green">客戶列表：{{ this.total }}位客戶</h4>
      <div class="mb-2 f-w-600 text-red">須持續服務之客戶將於完成編輯後翌日自「待刪除客戶」名單中移除</div>
    </section>
    <section>
      <div class="container-fluid">
        <div class="row">
          <data-table
            ref="dataTable"
            @update="updateSelection"
            @updateall="updateSelectAll"
            :options="tableOption"
            :table-data="tableDataBackup"
            :data-from="'TodayDeleteList'"
            :remote-data-msg="remoteDataMsg"
            @scheduled-access="ScheduledAccess"
            :scrollDataLoading="true"
            :dynamicLoading="true"
            :hasSearchBar="false"
          />
        </div>
      </div>
    </section>

    <section class="container-fluid">
      <fixed-botton v-show="!isScroll">
        <template slot="@function">
          <div>
            <button class="btn btn-default" @click="deleteResult" :disabled="!selection.length">刪除準保戶</button>
            <button
              class="btn btn-primary"
              @click="retainCust"
              :disabled="!selection.length"
            >需持續服務並保留</button>
            <button
              class="btn btn-primary mr-0"
              @click="openPrintModal"
              :disabled="!selection.length"
            >列印名條</button>
          </div>
        </template>
      </fixed-botton>
    </section>

    <!-- 刪除客戶 -->
    <warning-modal
      :open="WarningModalOpen"
      :message="deleteWarningMessage"
      @close="panelClose('WarningModalOpen')"
      @submit="submitDeleteResult"
    />

    <warning-modal
      :open="WarningDoubleCheckModalOpen"
      :message="WarningDoubleCheckModalMessage"
      :confirmText="`確認刪除`"
      @close="panelClose('WarningDoubleCheckModalOpen')"
      @submit="deleteCustomer"
    />
    <warning-modal
      :open="SystemDeleteTipOpen"
      :message="warningMessage"
      confirmText="我已了解"
      @submit="panelClose('SystemDeleteTipOpen')"
      :showCancel="false"
    />
    <!-- 列印 -->
    <print-modal
      :open="printModalOpen"
      :custs="selectionWithMobile"
      @close="panelClose('printModalOpen')"
    />
    <!-- 確認加入群組類型視窗 -->
    <confirm-group-modal
      :open="confirmGroupModalOpen"
      title="請選擇加入群組方式"
      @close="panelClose('confirmGroupModalOpen')"
      @addToCurrentGroup="addToCurrentGroup"
      @createNewGroup="createOneGroupOpen"
    />
    <!-- 成立新的群組視窗 -->
    <create-one-group-modal
      :open="createOneGroupModalOpen"
      :selectedCust="selection"
      type="SearchResultUse"
      @close="panelClose('createOneGroupModalOpen')"
      @createOneGroup="createOneGroup"
    />

    <!-- 排訪 -->
    <scheduled-access
      :open="ScheduledAccessModalOpen"
      :record="currentRecord"
      :cat-info="categoryInfo"
      @close="panelClose('ScheduledAccessModalOpen')"
      @submit="submitScheduledAccess"
    />

    <!-- 打開遮罩 -->
    <mxMask :open="mxMaskOpen" :content="maskMessage" />
  </main>
</template>

<script>
import { commonMixin } from "@/mixins/common";
import { mapActions, mapGetters } from "vuex";
import PrintModal from "../components/PrintModal";
import WarningModal from "../components/WarningModal";
import DataTable from "../../components/DataTable/DataTableScroll";
import FixedBotton from "../components/fixedBotton";
import { getTodayDeleteList, deleteCust, doSortList, retainCustomers } from "@/service";
import mxMask from "@/desktop/components/mxMask";
import ConfirmGroupModal from "@/desktop/components/ConfirmGroupModal";
import CreateOneGroupModal from "@/desktop/components/CreateOneGroupModal";
import ScheduledAccess from "@/desktop/components/ListsArea/ScheduledAccess";

export default {
  name: "TodayDeleteList",
  mixins: [commonMixin],
  watch: {
    checkAll: function(val) {
      if (val && this.checkAllClick) {
        this.selection = [];
        this.tableDataBackup.forEach(data => {
          this.selection.push(data.id);
        });
      } else if (this.checkAllClick) {
        this.selection = [];
      }
    },
    selection: function() {
      if (this.tableDataBackup.length == 0) {
        this.checkAll = false;
      } else if (
        this.tableDataBackup.length !== this.selection.length &&
        !this.checkAllClick
      ) {
        this.checkAll = false;
      } else if (!this.checkAllClick) {
        this.checkAll = true;
      }
    }
  },
  components: {
    PrintModal,
    WarningModal,
    DataTable,
    FixedBotton,
    mxMask,
    ConfirmGroupModal,
    CreateOneGroupModal,
    ScheduledAccess
  },
  data() {
    return {
      tableData: [],
      tableDataBackup: [],
      orderBy: "name",
      orderAsc: true,
      SystemDeleteTipOpen: true,
      warningMessage: `依個人資料保護法須定期檢視客戶資訊，此客戶名單已4年6個月
<div>未更新，系統將於<span class="text-red">6個月後刪除</span>，若需展延保留，請針對以下欄位</div>
<div>（包含: <span class="text-red">家戶歸戶、個人資訊、保單資訊、備註、排訪</span> )</div>
<div><span class="text-red">擇一完成資料編輯或更新</span>。</div>`,
      remoteDataMsg: "資料讀取中，請稍候...",
      groupModalOpen: false,
      printModalOpen: false,
      checkAllClick: false,
      WarningModalOpen: false,
      WarningDoubleCheckModalOpen: false,
      checkAll: false,
      selection: [],
      selectionWithMobile: [],
      deleteWarningMessage: "您確定要刪除這些「準保戶」的客戶嗎？",
      WarningDoubleCheckModalMessage:
        "系統會同步刪除「<span style='color:red;'>客戶資訊</span>」、「<span style='color:red;'>保單健檢</span>」及「<span style='color:red;'>建議書</span>」相關資訊，確認刪除後資料將無法回復，請確認是否刪除？",
      checkAll_f: false,
      isScroll: false, //是否滾動
      tableOption: {
        checkAll: true,
        scrollHeight: 550,
        checkBoxHasUser: true,
        columns: [
          {
            width: 130,
            name: "name",
            label: "姓名",
            sorting: true,
            click: data => {
              this.routeToCustDetail(data.id);
            }
          },
          {
            width: 130,
            name: "showid",
            sortName: "id",
            label: "身分證",
            sorting: true
          },
          {
            width: 130,
            name: "mobile",
            label: "手機",
            sorting: true
          },
          // {
          //   width: 130,
          //   name: "phone",
          //   label: "電話",
          //   sorting: true
          // },
          {
            width: 130,
            name: "birthday",
            label: "生日",
            sorting: true
          },
          {
            width: 300,
            name: "address",
            sorting: true,
            label: "住家地址"
          },
          // {
          //   width: 101,
          //   name: "idmark",
          //   label: "公司往來"
          // }
          {
            width: 130,
            name: "cnt",
            sorting: true,
            label: "刪除倒數日"
          },
          {
            name: "visit",
            label: "排訪"
          },
        ],
        sortByName: () => {
          this.orderAsc = !this.orderAsc;
          this.sortByName();
        }
      },
      mxMaskOpen: false,
      categoryInfo: {
        category_name: '疏遠聯繫'
      },
      confirmGroupModalOpen: false,
      createOneGroupModalOpen: false,
      ScheduledAccessModalOpen: false,
      currentRecord: {},
      isLoading: false,
      maskMessage: '資料刪除中，請稍候...'
    };
  },
  methods: {
    ...mapActions(["setPageLock", "updateCustID", "updateSerNo", "setListAreaSerNo"]),
    updateSelection(val) {
      this.selection = val;
    },
    updateSelectAll(val) {
      this.checkAll_f = val;
    },
    deleteResult() {
      this.panelOpen("WarningModalOpen");
    },
    retainCust(){
      retainCustomers(this.$store.state.userInfo.id, this.selection, "").then(
        result => {
        if (result && result.header.status == "200") {
          this.$toast.info({ title: `資料已更新` });
          this.$router.push({ path: `/` });
        } else {
          this.$toast.info({ title: `資料更新失敗` });
        }
      });
    },
    submitDeleteResult() {
      this.panelClose("WarningModalOpen");
      this.panelOpen("WarningDoubleCheckModalOpen");
    },
    submitGroup(group) {
      // add group methods
      this.panelClose("groupModalOpen");
      this.$router.push({
        path: `/group/1`,
        query: { grp_id: group.grp_id, grp_name: group.grp_name }
      });
    },
    ScheduledAccess(record) {
      this.currentRecord = record;
      this.panelOpen("ScheduledAccessModalOpen");
    },
    submitScheduledAccess() {
      this.panelClose("ScheduledAccessModalOpen");
      // 資料初始化
      this.init();
    },
    //取得性別
    getGender(csid) {
      if (!csid || !csid.trim()) {
        return;
      }
      let id = csid.toUpperCase();
      let gender = "";
      if (id.match("1|8|A|C")) {
        gender = 1;
      } else if (id.match("2|9|B|D")) {
        gender = 2;
      }
      return gender;
    },
    routeToCustDetail(custId) {
      let isSerNo = custId.startsWith("~") ? true : false;
      // updata Vuex data
      if (!isSerNo) {
        //有ID
        this.updateCustID(custId);
        this.updateSerNo("");
        localStorage.CustID = custId;
        localStorage.SerNo = "";
        this.$router.push({ path: `/detail/CustID/tab/1` });
      } else {
        //無ID，取serNo
        this.updateSerNo(custId);
        this.updateCustID("");
        localStorage.CustID = "";
        localStorage.SerNo = custId;
        this.$router.push({ path: `/detail/CustID/tab/1` });
      }
    },
    openPrintModal() {
      //排序從[點選順序]變更為[目前Table的排序]
      this.selection = this.sortByPattern(
        "id",
        this.tableDataBackup,
        this.selection
      );
      this.selectionWithMobile = [];
      this.selection.forEach(sel => {
        let tmpData = this.tableDataBackup.find(data => {
          return data.id === sel;
        });
        if (tmpData) {
          this.selectionWithMobile.push(tmpData);
        }
      });
      this.panelOpen("printModalOpen");
    },
    sortByPattern(propertyStr, patternObjectArray, targetArray) {
      let targetWithIndexArray = [];
      let targetCount = targetArray.length;
      let patternCount = patternObjectArray.length;
      for (let i = 0; i < targetCount; i++) {
        let targetProperty = targetArray[i];
        for (let j = 0; j < patternCount; j++) {
          if (targetProperty == patternObjectArray[j][propertyStr]) {
            let obj = {};
            obj["index"] = j;
            obj[propertyStr] = targetProperty;
            targetWithIndexArray.push(obj);
            break;
          }
        }
      }
      let sortedArray = targetWithIndexArray.sort(
        this.sortCompareFun(1, "index")
      );
      return sortedArray.map(ele => {
        return ele[propertyStr];
      });
    },
    sortCompareFun(sortOrder, property) {
      return function(a, b) {
        let result =
          a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
      };
    },
    deleteCustomer() {
      this.panelOpen("mxMaskOpen"); //開啟遮罩
      deleteCust(
        this.$store.state.userInfo.id,
        "csids",
        "",
        "",
        this.selection
      ).then(result => {
        this.panelClose("mxMaskOpen"); //關閉遮罩
        if (result && result.header.status == "200") {
          this.panelClose("WarningDoubleCheckModalOpen");
          this.$toast.info({ title: `刪除成功` });
          this.$router.push({ path: `/` });
        } else {
          this.panelClose("WarningDoubleCheckModalOpen");
          this.$toast.info({ title: `刪除失敗` });
        }
      });
    },
    handleScroll() {
      // ----滾動顯示/隱藏----
      this.isScroll = true;
      clearTimeout(this.scrolltimeOutProcessId);
      this.scrolltimeOutProcessId = setTimeout(() => {
        this.isScroll = false;
      }, 500);
      // ----滾動顯示/隱藏----
    },
    init() {
      this.setListAreaSerNo("DEL") // 刪除客戶的serno設為DEL
      this.tableDataBackup = [];
      this.remoteDataMsg = "資料讀取中，請稍候...";
      getTodayDeleteList(
        this.$store.state.userInfo.id,
        this.orderBy,
        this.orderAsc ? "asc" : "desc"
      )
        .then(result => {
          if (
            result.header &&
            (result.header.status == "200" || result.header.status == "0")
          ) {
            this.tableData = result.body.map((i, index) => {
              i.index = index + 1;
              i.showid = i.id.startsWith("~") ? "" : i.id;
              i.vip_level = Number(i.vip_lvl || "0");
              i.cnt = i.cnt == '' ? '天' : 180 - Number(i.cnt) + '天'
              i.address =
                (i.home_addr_zip || "") +
                (i.home_addr1 || "") +
                (i.home_addr2 || "") +
                (i.home_addr3 || "");
              i.company_address =
                (i.corp_addr_zip || "") +
                (i.corp_addr1 || "") +
                (i.corp_addr2 || "") +
                (i.corp_addr3 || "");
              let ageText = this.paddingLeft(i.age == "0" ? "0" : i.age ? i.age : "00000", 4, "0");
              let birthdayText = i.birthday || "0000-01-01";
              i.birthdaySort = ageText + "_" + birthdayText;
              i.visit = {};
              return i;
            });
          } else {
            this.tableData = [];
            this.setToastMsg(result.header.message);
          }
          this.tableDataBackup = [...this.tableData];
        })
        .finally(() => {
          this.remoteDataMsg = "查無資料";
          this.registerHanlink(); // 難字顯示
        });
      this.tableOption.scrollHeight = $(window).height() - 260;
    },
    //依姓名筆劃排序
    sortByName() {
      if(this.tableDataBackup.length == 0) {
        return;
      }
      
      let tempData = this.tableDataBackup;
      this.tableDataBackup = [];
      this.remoteDataMsg = "資料排序中，請稍候...";
      doSortList(
        this.$store.state.userInfo.id,
        this.orderAsc ? "1" : "-1",
        tempData,
        "name"
      ).then(result => {
        if (result.header && result.header.status === "200") {
            this.tableDataBackup = result.body.result;
            this.tableDataBackup.forEach((item, index) => {
              item.index = `${index + 1}`;
            } );
        } else {
          if (result.header && result.header.message) {
            this.$toast.info({ title: result.header.message });
          } else {
            this.$toast.info({ title: "姓名排序異常,請重新操作" });
          }
          this.tableDataBackup = tempData;
        }
        this.remoteDataMsg = "查無資料，請確認您輸入之資料是否正確";
      });
    },
    //導頁至加入現有群組(view)
    addToCurrentGroup() {
      this.panelClose("confirmGroupModalOpen");
      let selectionInfo = this.getSelectedCustInfo();
      this.$router.push({
        name: "add-to-current-group",
        params: { selectedCust: selectionInfo }
      });
    },
    //開啟成立新的群組視窗
    createOneGroupOpen() {
      this.panelClose("confirmGroupModalOpen");
      this.panelOpen("createOneGroupModalOpen");
    },
    //導頁至成立新的群組(view)
    createOneGroup(groupName) {
      let selectionInfo = this.getSelectedCustInfo();
      this.panelClose("createOneGroupModalOpen");
      this.$router.push({
        name: "create-one-group",
        params: { selectedCust: selectionInfo, groupName: groupName }
      });
    },
    //取得當前勾選客戶的資料
    getSelectedCustInfo() {
      let selectionInfo = [];
      this.selection.forEach(sel => {
        let tmpData = this.tableData.find(data => {
          return data.id === sel;
        });
        if (tmpData) {
          selectionInfo.push({
            showid: tmpData.showid,
            id: tmpData.id,
            name: tmpData.name,
            birthday: tmpData.birthday
          });
        }
      });
      return selectionInfo;
    }
  },
  computed: {
    ...mapGetters(["BaseUrl", "RouterPara"]),
    // 計算篩選結果客戶數量
    total() {
      return this.tableDataBackup.length;
    }
  },
  async mounted() {
    await this.init();
    window.addEventListener("scroll", this.handleScroll, true);
    let self = this;
    $(window).bind("resize", function() {
      self.tableOption.scrollHeight = $(window).height() - 310;
    });
  }
};
</script>
<style lang="scss" scoped>
.dropdown-menu-left {
  left: -16px !important;
}
.filter-result-table thead tr,
.filter-result-table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}
.list.badgets .badget.gray.item {
  padding: 0 22px;
  color: #323a45;
  background: #e0e1e3;
  border-radius: 8px;
  margin-right: 10px;
  margin-top: 10px;
}

.f-w-600 {
  font-weight: 600;
}

.filter-result-table tbody {
  display: block;
  height: 350px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 17px;
    border: 0;
    box-shadow: none;
  }

  &::-webkit-scrollbar-track {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }
  @media screen and (max-width: 1024px) {
    #datatable {
      width: 77rem;
    }
  }

  @media screen and (max-width: 768px) {
    #datatable {
      width: 70rem;
    }
  }
}
</style>
